import { assign, createMachine } from "xstate";
import { getEsimQRCode } from "@nju/data-access-portal-sim-card";
import { BasicError } from "@nju/result";

interface IContext {
  userId: string;
  iccId: string;
  matchingId: string;
}

type IEvent =
  | { type: "ERROR" }
  | { type: "SUCCESS" }
  | { type: "FETCH_DATA_SUCCESS"; matchingId: string | undefined };

export const changeEsimCardReadyMachine = createMachine(
  {
    schema: {
      context: {} as IContext,
      events: {} as IEvent,
    },
    initial: "init",
    states: {
      init: {
        invoke: {
          src: "fetchData",
        },
        on: {
          FETCH_DATA_SUCCESS: {
            actions: "setData",
            target: "success",
          },
        },
      },
      success: {
        type: "final",
      },
    },
  },
  {
    actions: {
      setData: assign<IContext, IEvent>((context, event) => {
        if (event.type === "FETCH_DATA_SUCCESS") {
          return {
            matchingId: event.matchingId,
          };
        }

        return context;
      }),
    },
    services: {
      fetchData: ({ iccId, userId }) => {
        return async (callback) => {
          try {
            const result = (await getEsimQRCode({ iccId, userId })).unwrap();

            if (!result) {
              throw new BasicError({
                message: "Missing matchingId from esims",
              });
            }

            return callback({
              type: "FETCH_DATA_SUCCESS",
              matchingId: result.eSim?.matchingId,
            });
          } catch {
            callback({ type: "ERROR" });
          }
        };
      },
    },
  },
);
